import { createTheme } from '@mui/material/styles';
import './kaiti.css';
// import './heiti.css';

const theme = createTheme({
    typography: {
      h3: {
        fontFamily: "PT Serif, Kaiti",
        fontSize: "28px"
      },
      h1: {
        fontFamily: "PT Serif, Kaiti",
        fontSize: "32px",
        fontWeight: "600"
      },
      h2: {
        fontFamily: "PT Serif, Kaiti",
        fontSize: "24px",
        fontWeight: "600"
      },
      h6: {
        fontFamily: "PT Serif, Noto Sans TC",
        fontSize: "20px",
        fontWeight: "400"
      },
      subtitle1: {
        fontFamily: "PT Serif, Noto Sans TC",
        fontSize: "16px",
        fontWeight: "400",
        fontStyle: "italic"
      },
      body1: {
        fontFamily: "PT Serif, Noto Sans TC",
        fontSize: "16px",
        fontWeight: "400",
      }
    },
  });

export default theme;